/** This list is currently still in the Design System but will be migrated over */
const backgroundThemesRaw = {
	none: '',
	black: 'bg-black text-white fill-white',
	midnight_blue: 'bg-midnight-blue text-white fill-white',
	salmonella_360: 'bg-salmonella_360 text-black fill-black text-black-links',
	zenrelia_primary: 'bg-zenrelia_primary text-white fill-white',
	zenrelia_secondary: 'bg-zenrelia_secondary text-white fill-white',
	zenrelia_contrast: 'bg-zenrelia_contrast text-white fill-white',
	zenrelia_accent:
		'bg-zenrelia_accent text-black fill-black text-black-links',
	zenrelia_sku1: 'bg-zenrelia_sku1 text-white fill-white',
	zenrelia_sku2: 'bg-zenrelia_sku2 text-white fill-white',
	zenrelia_sku3: 'bg-zenrelia_sku3 text-white fill-white',
	zenrelia_sku4: 'bg-zenrelia_sku4 text-black fill-black text-black-links',
	claro_neptra: 'bg-claro_neptra text-white fill-white',
	advocate_orange:
		'bg-advocate_orange text-black fill-black text-black-links',
	elanco_blue: 'bg-elanco-blue text-white fill-white text-white-links',
	elanco_beige: 'bg-elanco-beige text-black fill-black text-black-links',
	pet_green: 'bg-pet-green text-white fill-white',
	vet_purple: 'bg-vet-purple text-white fill-white',
	white: 'bg-white text-black fill-black text-black-links',
	elanco_green: 'bg-elanco-green text-black fill-black text-black-links',
	elanco_grey: 'bg-elanco-grey text-white fill-white',
	light_blue: 'bg-light-blue text-black fill-black text-black-links',
	light_gray: 'bg-light_gray text-black fill-black text-black-links',
	mid_beige: 'bg-mid-beige text-black fill-black text-black-links',
	pet_green_light:
		'bg-pet-green-light text-black fill-black text-black-links',
	purple_light: 'bg-purple-light text-black fill-black text-black-links',
	kexxtone: 'bg-kexxtone text-black fill-black text-black-links',
	zolvix_orange: 'bg-zolvix_orange text-black fill-black text-black-links',
	bexacat_orange: 'bg-bexacat_orange text-white fill-white text-white-links',
	parvo: 'bg-parvo text-white fill-white',
	droncit_red: 'bg-droncit_red text-white fill-white',
	varenzin_red: 'bg-varenzin_red text-white fill-white',
	bexacat: 'bg-bexacat text-black fill-black text-black-links',
	adtab_yellow: 'bg-adtab_yellow text-black fill-black text-black-links',
	adtab_black: 'bg-adtab_black text-white fill-white',
	adtab_white: 'bg-adtab_white text-black fill-black text-black-links',
	gallipro_fit_yellow:
		'bg-gallipro_fit_yellow text-black fill-black text-black-links',
	gallipro_fit_orange:
		'bg-gallipro_fit_orange text-black fill-black text-black-links',
	gallipro_fit_green:
		'bg-gallipro_fit_green text-black fill-black text-black-links',
	gallipro_fit_darkblue: 'bg-gallipro_fit_darkblue text-white fill-white',
	neptra_green: 'bg-neptra_green text-black fill-black text-black-links',
	seresto: 'bg-seresto text-white fill-white',
	clik_light_blue: 'bg-clik_light_blue text-white fill-white',
	clik_dark_blue: 'bg-clik_dark_blue text-white fill-white',
	clik_yellow: 'bg-clik_yellow text-black fill-black text-black-links',
	tracer: 'bg-tracer text-white fill-white',
	bovaer: 'bg-bovaer text-white fill-white',
	pradalex: 'bg-pradalex text-white fill-white',
	avipro_grey: 'bg-avipro_grey text-white fill-white',
	avipro_red: 'bg-avipro_red text-white fill-white',
	aviblue_light_blue: 'bg-aviblue_light_blue text-white fill-white',
	aviblue_mid_blue: 'bg-aviblue_mid_blue text-white fill-white',
	aviblue_dark_blue: 'bg-aviblue_dark_blue text-white fill-white',
	coliprotec_teal: 'bg-coliprotec_teal text-white fill-white',
	flubenvet: 'bg-flubenvet text-white fill-white',
	hemicell_red: 'bg-hemicell_red text-white fill-white',
	htsi: 'bg-htsi text-white fill-white',
	maxiban_: 'bg-maxiban_ text-white fill-white',
	galliprant_yellow:
		'bg-galliprant_yellow text-black fill-black text-black-links',
	onsior: 'bg-onsior text-white fill-white',
	onsior_cool_gray_10: 'bg-onsior_cool_gray_10 text-white fill-white',
	onsior_tangerine: 'bg-onsior_tangerine text-white fill-white',
	onsior_dark_gray: 'bg-onsior_dark_gray text-white fill-white',
	onsior_cool_gray_6c: 'bg-onsior_cool_gray_6c text-white fill-white',
	onsior_dark_red: 'bg-onsior_dark_red text-white fill-white',
	onsior_vivid_orange: 'bg-onsior_vivid_orange text-white fill-white',
	onsior_dark_violet: 'bg-onsior_dark_violet text-white fill-white',
	onsior_lime_green: 'bg-onsior_lime_green text-white fill-white',
	onsior_dark_blue: 'bg-onsior_dark_blue text-white fill-white',
	onsior_rhodamine_red: 'bg-onsior_rhodamine_red text-white fill-white',
	onsior_advantix_light: 'bg-onsior_advantix_light text-white fill-white',
	agita_10wg: 'bg-agita_10wg text-white fill-white',
	baseline: 'bg-baseline text-white fill-white',
	baytril_100: 'bg-baytril_100 text-white fill-white',
	evosure: 'bg-evosure text-white fill-white',
	feedaid: 'bg-feedaid text-white fill-white',
	full_value_pork_primary_blue:
		'bg-full_value_pork_primary_blue text-white fill-white',
	full_value_pork_secondary_blue:
		'bg-full_value_pork_secondary_blue text-white fill-white',
	lipinate: 'bg-lipinate text-white fill-white',
	pili_shield_plus_c: 'bg-pili_shield_plus_c text-white fill-white',
	proteck: 'bg-proteck text-white fill-white',
	rhini_shield: 'bg-rhini_shield text-white fill-white',
	swine_awake: 'bg-swine_awake text-white fill-white',
	tempo_one_percent_dust: 'bg-tempo_one_percent_dust text-white fill-white',
	credelio_quattro_guard_dog:
		'bg-credelio_quattro_guard_dog text-white fill-white',
	credelio_quattro_hunter_green:
		'bg-credelio_quattro_hunter_green text-white fill-white',
	credelio_quattro_grass_green:
		'bg-credelio_quattro_grass_green text-white fill-white',
	credelio_quattro_tennis_ball_green:
		'bg-credelio_quattro_tennis_ball_green text-white fill-white',
	credelio_quattro_park_green:
		'bg-credelio_quattro_park_green text-black fill-black text-black-links',
	credelio_quattro_milk_bone:
		'bg-credelio_quattro_milk_bone text-black fill-black text-black-links',
	credelio_quattro_golden: 'bg-credelio_quattro_golden text-white fill-white',
	credelio_quattro_frisbee:
		'bg-credelio_quattro_frisbee text-white fill-white',
	credelio_quattro_sunny_day:
		'bg-credelio_quattro_sunny_day text-white fill-white',
	credelio_quattro_sky_blue:
		'bg-credelio_quattro_sky_blue text-white fill-white',
	pet_protect_red: 'bg-pet_protect_red text-white',
	pet_protect_green: 'bg-pet_protect_green text-white',
	pet_protect_blue: 'bg-pet_protect_blue text-white',
	pet_protect_skin: 'bg-pet_protect_skin text-white',
	pet_protect_calm: 'bg-pet_protect_calm text-white',
	pet_protect_allergy: 'bg-pet_protect_allergy text-white',
	civ: 'bg-civ text-white',
	elmaro_navy_blue: 'bg-elmaro_navy_blue text-white',
	elmaro_pink: 'bg-elmaro_pink text-white',
	elmaro_yellow: 'bg-elmaro_yellow text-white',
	galliprant_red: 'bg-galliprant_red text-white',
	bexacat_dark_grey: 'bg-bexacat_dark_grey text-white',
	rosa_xo_verme: 'bg-rosa_xo_verme text-white',
	catosal_metabol: 'bg-catosal_metabol text-white',
	varenzin_blue: 'bg-varenzin_blue text-white',
	varenzin_purple: 'bg-varenzin_purple text-white',
	nuplura_ph_plus_5_primary: 'bg-nuplura_ph_plus_5_primary text-white',
	nuplura_ph_plus_5_secondary: 'bg-nuplura_ph_plus_5_secondary text-white',
	befrena_primary_blue: 'bg-befrena_primary_blue text-white',
	befrena_accent_green: 'bg-befrena_accent_green text-white',
	befrena_accent_pink: 'bg-befrena_accent_pink text-white',
	eluracat_dark_pink: 'bg-eluracat_dark_pink text-white',
	eluracat_light_pink: 'bg-eluracat_light_pink text-white',
	eluracat_yellow: 'bg-eluracat_yellow text-white',
	zolvix_plus_green: 'bg-zolvix_plus_green text-white',
	zolvix_plus_orange: 'bg-zolvix_plus_orange text-white',
	milbemax_red: 'bg-milbemax_red text-white text-white-links',
	milbemax_blue: 'bg-milbemax_blue text-white text-white-links',
	trucan_ultra_blue: 'bg-trucan_ultra_blue text-white',
	trucan_ultra_yellow: 'bg-trucan_ultra_yellow text-black',
	bexacat_bright_purple:
		'bg-bexacat_bright_purple text-white fill-white text-white-links',
	bexacat_purple_accent:
		'bg-bexacat_purple_accent text-white fill-white text-white-links',
	tru_crew_blue: 'bg-tru_crew_blue text-white',
	tru_crew_mint: 'bg-tru_crew_mint text-white',
	advocate_uc_gold: 'bg-advocate_uc_gold text-white',
	hemicell_orange: 'bg-hemicell_orange text-white',
}

export const backgroundThemes = new Map(Object.entries(backgroundThemesRaw))
